module.exports = __webpack_public_path__ + "img/logo.429f2742.svg";